import type { ChoroplethLayerDef } from './types';

export const GREY = '#9e9e9e';
export const NO_DATA_COLOR = '#e0e0e0';

export function h2r(hex: string): [number, number, number] {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return [r, g, b];
}

export function r2h(r: number, g: number, b: number): string {
  return (
    '#' +
    [r, g, b]
      .map((v) =>
        Math.round(Math.max(0, Math.min(255, v)))
          .toString(16)
          .padStart(2, '0'),
      )
      .join('')
  );
}

export function blendHex(c1: string, c2: string, t: number): string {
  const [r1, g1, b1] = h2r(c1);
  const [r2, g2, b2] = h2r(c2);
  const tc = Math.max(0, Math.min(1, t));
  return r2h(r1 + (r2 - r1) * tc, g1 + (g2 - g1) * tc, b1 + (b2 - b1) * tc);
}

export function colorFor(layerDef: ChoroplethLayerDef, value: number): string {
  const { stops, palette } = layerDef;
  if (!isFinite(value)) return NO_DATA_COLOR;
  if (value <= stops[0]) return palette[0];
  if (value >= stops[stops.length - 1]) return palette[palette.length - 1];

  // Защита: если stops длиннее palette — clamp индекс палитры к последнему цвету.
  // Иначе blendHex(palette[i], undefined) крашится.
  const maxIdx = palette.length - 1;
  for (let i = 0; i < stops.length - 1; i++) {
    if (value >= stops[i] && value < stops[i + 1]) {
      const t = (value - stops[i]) / (stops[i + 1] - stops[i]);
      const a = palette[Math.min(i, maxIdx)];
      const b = palette[Math.min(i + 1, maxIdx)];
      return blendHex(a, b, t);
    }
  }
  return palette[palette.length - 1];
}
